/**
 * Prototype switch for the fridge type without dish RFID readers (`?flow=nonRfid`). Read from the URL
 * only — the playground passes it on every reload — and never in production builds. The backend
 * capability flag replaces it once the real non-RFID flow ships.
 */
export const isNonRfidFlow = (): boolean => {
	if (import.meta.env.MODE === "production") {
		return false;
	}
	return new URLSearchParams(window.location.search).get("flow") === "nonRfid";
};
